import type { FC } from 'react';
import MultiAutocompleteFilter from './MultiAutocompleteFilter';
import type { FilterSize } from './filterSize';

interface HypothesisAutocompleteProps {
  value: string[];
  options: string[];
  onChange: (val: string[]) => void;
  minWidth?: number;
  size?: FilterSize;
}

const HypothesisAutocomplete: FC<HypothesisAutocompleteProps> = (props) => (
  <MultiAutocompleteFilter label="Hypothesis" {...props} />
);

export default HypothesisAutocomplete;
